module.exports = __webpack_public_path__ + "static/media/ic-editar.25ec1cbe.svg";